// Delegate — the headless hook moved to `@heidi/workspace/data` (OT4,
// ARCFE-1033). This file owns the app reaction (ARCFE-921): the destructive
// toast, its intl copy, and the backend `detail.msg` extraction. The port fires
// only inside the transport-error branch, exactly as `instanceof AxiosError`
// gated it before.
import { type ErrorResponse } from '@/types';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import {
  useMutateInviteUsersToOrgTeam as useMutateInviteUsersToOrgTeamCore,
  type WorkspaceHttpError,
} from '@heidi/workspace/data';

export function useMutateInviteUsersToOrgTeam() {
  const { t } = useTranslations();

  return useMutateInviteUsersToOrgTeamCore({
    onInviteError: (error: WorkspaceHttpError) => {
      const errorData = error.response?.data as ErrorResponse;
      toast({
        tone: 'destructive',
        title: t('organization.failedToSendOrganizationInvitation'),
        description: errorData.detail.msg,
      });
    },
  });
}
